import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Setor } from 'src/app/models/setor';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { SetorService } from 'src/app/services/setor.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-cadastrar-setor-modal',
  templateUrl: './cadastrar-setor-modal.component.html',
  styleUrls: ['./cadastrar-setor-modal.component.scss']
})
export class CadastrarSetorModalComponent implements OnInit {
  idSetor: number;
  setor: Setor = new Setor();
  public config: PerfectScrollbarConfigInterface = {};
  editando: boolean;
  carregando: boolean;

  constructor(public dialogRef: MatDialogRef<CadastrarSetorModalComponent>, private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService,
    private spinner: NgxSpinnerService, private utilitarioService: UtilitarioService, private carregandoService: CarregandoService, private setorService: SetorService) {
    this.idSetor = data.idSetor;
  }

  ngOnInit(): void {
    if (this.idSetor) {
      this.editando = true;
      this.buscarSetor();
    } else {
      this.setor = new Setor();
    }
  }

  salvar() {
    this.carregandoService.mostra('salvarSetor');
    this.setorService.salvar(this.setor).subscribe((retorno) => {
      this.notificacaoService.sucesso('Setor salvo com sucesso!!!');
      this.carregandoService.esconde('salvarSetor');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvarSetor');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarSetor() {
    this.carregandoService.mostra('buscarSetor');

    this.setorService.consultarPorIdSetor(this.idSetor).subscribe((data: any) => {
      this.setor = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarSetor');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetor');
      this.notificacaoService.erro(erro);
    });
  }

  validar() {
    return this.setor.descricao !== null && this.setor.descricao !== undefined;
  }
}
